<template>
  <div :class="{ blue }" class="HRModule">
    <hr-header
      :no-header="noHeader"
      :mobile-header="mobileHeader"
      :mobile-menu="mobileMenu"
      @menuClicked="menuToggler"
    />

    <div class="HRModule__logo-container">
      <img
        v-if="logo"
        class="HRModule__logo"
        src="../../static/images/logo-icon-color.svg"
      />
    </div>

    <div v-if="$slots.left" class="HRModule__body">
      <div
        :class="{
          'hidden-xs': !mobileMenu,
          mobileMenu,
          active: menuState,
          blue: leftPanelBlue,
        }"
        class="HRModule__body__left col-xs-12 col-sm-6"
      >
        <img
          class="HRModule__logo--left-panel"
          src="../../static/images/logo-icon-color.svg"
        />
        <slot name="left"></slot>
        <div class="hr-welcome__image_container">
          <img
            v-if="logoLeftPanel"
            class="hr-welcome__image"
            src="../../static/images/welcome-small@2x.png"
          />
        </div>
      </div>
      <div
        class="HRModule__body__right col-xs-12 col-sm-6"
        data-testid="hr-module-body-right"
      >
        <div
          class="HRModule__body__right__content col-xs-12 col-sm-11 col-md-9 col-lg-8 col-centered"
        >
          <slot name="right"></slot>
          <slot></slot>
        </div>
      </div>
    </div>

    <div v-if="!$slots.left" class="HRModule__body standalone">
      <slot></slot>
    </div>

    <div v-if="$slots.footer" class="HRModule__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import store from '@/store';
import HrHeader from '@/components/hr-header';

export default {
  name: 'hrmodule',
  components: { HrHeader },
  props: {
    noHeader: {
      type: Boolean,
      default: false,
    },
    blue: {
      type: Boolean,
      default: false,
    },
    mobileMenu: {
      type: Boolean,
      default: false,
    },
    mobileHeader: {
      type: Boolean,
      default: false,
    },
    logo: {
      type: Boolean,
      default: false,
    },
    logoLeftPanel: {
      type: Boolean,
      default: false,
    },
    leftPanelBlue: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const menuState = computed(() => store.state.menuState);

    function menuToggler() {
      store.commit('menuToggle');
    }

    return {
      menuState,
      menuToggler,
    };
  },
};
</script>

<style scoped lang="scss">
@import '~@/core/style-vars.scss';

.hr-welcome__image_container {
  text-align: center;
  margin: 18px 0;
}

.hr-welcome__image {
  max-width: 350px;
}

.HRModule__logo-container {
  position: fixed;
  width: 100%;
}

.HRModule__logo {
  margin-top: 14px;
  margin-left: 14px;
  height: 26px;
}

.HRModule__body__left.blue {
  background: $early-dawn-background;
  color: $white;
}

.HRModule__logo--left-panel {
  top: 14px;
  left: 14px;
  height: 26px;
  position: absolute;
  z-index: 2;
  color: $white;
}

.HRModule.blue {
  background: $early-dawn-background;
}

.HRModule {
  background: transparent;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.HRModule__body.standalone {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: auto;
}

.HRModule__body {
  height: 100%;
  flex: 1;
  overflow: hidden;
}

.HRModule__body__right__content {
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;

  position: static;
}

.HRModule .HRHeader.rightSideHeaderMobile {
  display: none;
}

.HRModule__body__left {
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 52px 0 160px;
  background: var(--co-background-primary);
  border-right: 1px solid var(--co-lines-border-solid);
}

.HRModule__body__right {
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 0 100px;

  @media (min-width: 768px) {
    padding-top: 52px;
  }
}

@media (max-width: 767px) {
  .HRModule__body__left.mobileMenu {
    position: absolute;
    top: 0;
    left: -110%;
    z-index: 4;
    transition: left 0.6s ease;
    padding-top: 50px;
    box-shadow: 4px 4px 4px 0 $white-dark;
  }

  .HRModule__body__left.active {
    left: 0;
  }

  .HRModule__body__right {
    height: 100%;
    overflow: auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding-bottom: 0px;
  }
}

.HRModule__footer {
  z-index: 4;
}

@media print {
  .HRModule,
  .HRModule__body {
    overflow: visible !important;
  }
}
</style>
